import { apiService } from "api/apiService";

export interface AIFeedbackRewrite {
  /** The text that was sent, as the backend filtered it. */
  input: string;
  messages: { message: string }[];
}

/** Which of the two fields is being rewritten; each has its own prompt. */
export type RewriteField = "feedback" | "feedforward";

/**
 * Rewrite the feedback or feedforward a teacher typed into three alternatives.
 *
 * The text is posted rather than read from the rating server-side: the field
 * autosaves on a debounce, so the stored column lags behind what the teacher is
 * looking at (AI-FEEDBACK-REWRITE-SOURCE-001).
 */
export const createFeedbackRewrite = async (
  ratingId: number | string,
  feedback: string,
  field: RewriteField,
  signal?: AbortSignal,
): Promise<AIFeedbackRewrite> => {
  const { data } = await apiService.post<AIFeedbackRewrite>(
    `/api/catwise-ai/ratings/${ratingId}/rewrite-feedback`,
    { feedback, field },
    { signal },
  );

  return data;
};
